let ip = window.location.origin
console.log(ip);
export default {
	baseURL:ip
}
